import { render, staticRenderFns } from "./GlobalConfiguration.vue?vue&type=template&id=1d710786&scoped=true&"
import script from "./GlobalConfiguration.vue?vue&type=script&lang=js&"
export * from "./GlobalConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./GlobalConfiguration.vue?vue&type=style&index=0&id=1d710786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d710786",
  null
  
)

export default component.exports